import logout from '@helpers/auth/logout'
import useState from '@hooks/useState'

import Phone from './Phone'
import Profile from './Profile'

import styles from './styles.module.css'

export default function User(props) {
  const [editingPhone, setEditingPhone] = useState(false)

  return (
    <div className={styles.container}>
      {!props.user.profile.firstName ? (
        <Profile me={props.user} />
      ) : editingPhone || (!props.user.phone && props.deliveryType !== 'serve') ? (
        <Phone me={props.user} close={() => setEditingPhone(false)} />
      ) : (
        <div>
          <div>Nombre: {props.user.name}</div>
          <div>Email: {props.user.email}</div>
          <div>Teléfono: {props.user.phone}</div>
          <div className={styles.button} onClick={() => setEditingPhone(true)}>
            Cambiar teléfono
          </div>
          <div className={styles.button} onClick={() => logout()}>
            Cambiar email
          </div>
        </div>
      )}
    </div>
  )
}
